import { type MouseEvent, useState } from 'react';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { Chip, Menu, MenuItem } from '@mui/material';
import { useChangeAcademicStatus } from '@/data/learning/academic-situation';
import type { AcademicSituation } from '@/models/learning/academic-situation';
import { academicStatusConfig } from './status-config';
import {
  statusDropdownLabels,
  statusTransitions,
} from './status-transitions';

interface StatusChipDropdownProps {
  situation: AcademicSituation;
}

export const StatusChipDropdown = ({ situation }: StatusChipDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { mutate: changeStatus } = useChangeAcademicStatus();

  const status = academicStatusConfig[situation.current_status];
  const transitions = statusTransitions[situation.current_status];

  const chipSx = {
    backgroundColor: status.backgroundColor,
    color: status.color,
    fontWeight: 600,
  };

  if (transitions.length === 0) {
    return <Chip label={status.label} size="small" sx={chipSx} />;
  }

  const open = (event: MouseEvent<HTMLDivElement>) =>
    setAnchorEl(event.currentTarget);
  const close = () => setAnchorEl(null);

  const select = (statusType: (typeof transitions)[number]) => {
    close();
    changeStatus({ situationId: situation.id, statusType });
  };

  return (
    <>
      <Chip
        label={status.label}
        size="small"
        onClick={open}
        onDelete={open}
        deleteIcon={<KeyboardArrowDown />}
        sx={chipSx}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {transitions.map((statusType) => (
          <MenuItem key={statusType} onClick={() => select(statusType)} dense>
            {statusDropdownLabels[statusType]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
